export const GATEWAY_URL = "https://gateway.sgs.red";
export const ORANGU_URL = "https://console-backend.sgs.red";
export const ENV = "default";
export const BUILD_NAME = "";
export const BRAZE_API_KEY = "28e527ac-5c14-43cb-8481-35fbac306f90";
export const BRAZE_BASE_URL = "sdk.fra-01.braze.eu";
export const IS_LOCAL = false

